module.exports = __webpack_public_path__ + "img/product-5.c44d3c2e.jpg";